// Channel API client
import api from "./api";

export async function getChannel(userId) {
  const { data } = await api.get(`/channel/${userId}`);
  return data;
}
export async function getChannelBySlug(slug) {
  const { data } = await api.get(`/channel/by-slug/${encodeURIComponent(slug)}`);
  return data;
}
export async function updateMyChannel(payload) {
  const { data } = await api.put(`/channel/me`, payload);
  return data;
}
// Explicit opt-in: turn this user's channel on. Required before the
// /u/{user_id} page renders publicly. See backend channels.py — the
// `is_channel_active` flag is now (premium AND activated_at), so
// regular users (even premium) won't have a visible channel until
// they call this.
export async function activateMyChannel() {
  const { data } = await api.post(`/channel/activate`);
  return data;
}
// Explicit opt-out: hide this user's channel from the public surface.
// Keeps the channel_meta doc (banner, links, subscribers) intact so a
// re-activation later restores their setup; only `activated_at` is cleared.
export async function deactivateMyChannel() {
  const { data } = await api.delete(`/channel/activate`);
  return data;
}
export async function subscribeTo(userId) {
  const { data } = await api.post(`/channel/${userId}/subscribe`);
  return data;
}
export async function unsubscribeFrom(userId) {
  const { data } = await api.delete(`/channel/${userId}/subscribe`);
  return data;
}
// Bell preference for a channel I'm already subscribed to.
//   pref ∈ { "all", "personalized", "none" }
export async function setChannelNotifyPref(userId, pref) {
  const { data } = await api.put(`/channel/${userId}/subscribe/notify-pref`, { notify_pref: pref });
  return data;
}
export async function listMySubscriptions() {
  const { data } = await api.get(`/channel/me/subscriptions`);
  return data || [];
}
export async function listChannelSuggestions(limit = 8) {
  const { data } = await api.get(`/channel/suggestions`, { params: { limit } });
  return data || [];
}
